<div class="cta-buttons">
  @for (cta of _ctas; track cta.label) {
    @if (_getResult(cta.label); as result) {
      <span
        class="cta-result"
        [class.cta-result--success]="result.success"
        [class.cta-result--error]="!result.success"
      >
        {{ result.success ? '&#10003;' : '&#10007;' }}
        {{ result.message }}
      </span>
    } @else {
      <button
        class="cta-button"
        type="button"
        [disabled]="streaming() || _isPending(cta.label)"
        (click)="_onClick(cta)"
      >
        @if (_isPending(cta.label)) {
          <span class="cta-spinner"></span>
        }
        {{ cta.label }}
      </button>
    }
  }
</div>
